<div class="wrapper">
  <div #inputContainer>
    <ng-content></ng-content>
  </div>
  <a
    class="type-toggle"
    (click)="toggleShow()"
    *ngIf="hasRequiredError === false">
    <fa-icon
      class="show-option"
      [hidden]="showPassword"
      [icon]="faHide"></fa-icon>
    <fa-icon
      class="show-option"
      [hidden]="!showPassword"
      [icon]="faShow"></fa-icon>
  </a>
</div>
